export const BASE_URI_API = "https://fe.up.pt/natal/christmas-cards/api/";
//export const BASE_URI_API = 'http://localhost:8000/api/'
export const API_VERSION = "v1";
export const TOKEN_NAME = "token_sanctum";
